import { EntityType } from "@oysterhr/hiring/full-time-employee"
import {
  useNewHireEquipmentRemoteWorkCostMutation,
  UseNewHireEquipmentRemoteWorkCostMutationOptions,
} from "./useNewHireEquipmentRemoteWorkCostMutation"
import {
  useTemplateEquipmentRemoteWorkCostMutation,
  UseTemplateEquipmentRemoteWorkCostMutationOptions,
} from "./useTemplateEquipmentRemoteWorkCostMutation"

type useEquipmentRemoteWorkCostAgnosticMutationArgs = {
  entityType: EntityType
  options:
    | UseNewHireEquipmentRemoteWorkCostMutationOptions
    | UseTemplateEquipmentRemoteWorkCostMutationOptions
}

export const useEquipmentRemoteWorkCostAgnosticMutation = ({
  entityType,
  options,
}: useEquipmentRemoteWorkCostAgnosticMutationArgs) => {
  const useMutations =
    entityType === "engagement"
      ? useNewHireEquipmentRemoteWorkCostMutation
      : useTemplateEquipmentRemoteWorkCostMutation

  return useMutations(options as never)
}
